// import VueI18n from 'vue-i18n'
// import Vue from 'vue'
// import { DEFAULT_LANGUAGE, FALLBACK_LANGUAGE } from '@/constants/trans'
// import tr from '@/lang/tr.json'



// Vue.use(VueI18n);

// Vue.use(VueI18n)
// export const i18n = new VueI18n({
//   locale: DEFAULT_LANGUAGE, // set locale
//   fallbackLocale: FALLBACK_LANGUAGE,
//   messages: { tr }// set locale messages
// })
 //yeni

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import tr from '@/lang/tr.json'
import en from '@/lang/en.json'
import de from '@/lang/de.json'
import fr from '@/lang/fr.json'
import deC from '@/lang/deC.json'

Vue.use(VueI18n);

const messages = {
  tr, en, de, fr,deC
};


if( !localStorage.getItem("lang") ){
    let browserLang = Object.keys( messages ).find( (lang) => { return lang == navigator.language.substring(0,2) })
    browserLang ? localStorage.setItem( "lang", browserLang ) : localStorage.setItem( "lang", "en" )
}

export const i18n = new VueI18n({
     locale: localStorage.getItem("lang"),  
     fallbackLocale: 'tr', 
     messages,
});

export default i18n;



